import { defineMessages } from 'react-intl'

const scope = `procurify.accounts-payable.features.start-reconciliation-session.presenters.StartReconciliationSessionFormPresenter`

export default defineMessages({
  errorTitle: {
    id: `${scope}.errorTitle`,
    defaultMessage: 'Error',
  },
  genericErrorMessage: {
    id: `${scope}.genericErrorMessage`,
    defaultMessage: 'Unable to start the reconciliation session.',
  },
})
